import { createContext, useContext } from "react";

interface TableContextValue {
  rounded: boolean;
  hasHorizontalScroll: boolean;
}

export const TableContext = createContext<TableContextValue>({ rounded: true, hasHorizontalScroll: false });

export function useTableContext() {
  return useContext(TableContext);
}

